import React from 'react';
import PropTypes from 'prop-types';
import css from '../partials/Grid.css';
import { ReportFieldTypes } from '../../utils/consts';
import { getExactValueTooltipText } from '../../utils/grids';
import Tooltip from '../molecules/Tooltip';
import CellLoader from './CellLoader';
import withTranslate from '../../containers/widgets/withTranslate';

const TotalsCell = ({ value, valueFormatted, isLoading = false, colDef = {}, translate = () => {} }) => {
    if (colDef?.type === ReportFieldTypes.DIMENSION) return null;

    if (isLoading) return <CellLoader loaderClass={css.loadingCell} />;

    const exactValueText = getExactValueTooltipText(value, colDef?.context?.displayFormat, translate);

    if (exactValueText) {
        return (
            <Tooltip delay={250} title={exactValueText} contentClass={css.cellTooltip}>
                <span>{valueFormatted}</span>
            </Tooltip>
        );
    }

    return <span>{valueFormatted}</span>;
};

TotalsCell.propTypes = {
    value: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    valueFormatted: PropTypes.string,
    isLoading: PropTypes.bool,
    colDef: PropTypes.objectOf(PropTypes.any),
    translate: PropTypes.func,
};

export default withTranslate(TotalsCell);
